import React from "react";
import "../css/paysuccess.css";
import Header from "./Header";
import Footer from "./Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const PaySuccess = () => {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="success-page">
      <Header />
      <div className="success-container">
        <div className="success-box">
          <div className="checkmark-circle">
            <FontAwesomeIcon icon={faCheck} className="check-icon" />
          </div>
          <h1 className="success-title">Order Placed!</h1>
          <p className="success-text">Thank you for your purchase. Your order is being processed and we'll send you a confirmation email shortly.</p>
          <Link to="/shop" className="continue-btn" onClick={toTop}>CONTINUE SHOPPING</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PaySuccess;
